module.exports = __webpack_public_path__ + "img/insta_white.a1f7aeea.svg";